import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { Actions } from "@/store";
import Shortcut from "@/components/shortcut/Shortcut.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ShortcutPage',
  setup(__props) {

const store = useStore();
const route = useRoute();

onMounted(() => {
  store.dispatch(Actions.GetShortcut, route.params.id);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Shortcut))
}
}

})